const textFieldForgotPasswordConfirm = {
  email: 'Seu Email',
  password: 'Senha',
  helperText: 'Mínimo de 6 caracteres',
  confirmPassword: 'Confirme sua Senha',
  passwordError: 'Senhas diferentes'
};

export default textFieldForgotPasswordConfirm;
